/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_What_BodyInputs */

const tr_katalog_desi_page_what_body = /** @type {(inputs: Katalog_Desi_Page_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi (desimetreküp), bir kolinin kapladığı hacmin ağırlığa çevrilmiş halidir. Kargo firmaları, hafif ama hacimli paketleri adil ücretlendirmek için desiyi kullanır.`)
};

const en_katalog_desi_page_what_body = /** @type {(inputs: Katalog_Desi_Page_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi (cubic decimetre) is the volume of a box converted into weight. Carriers use desi to fairly price light but bulky packages.`)
};

const de_katalog_desi_page_what_body = /** @type {(inputs: Katalog_Desi_Page_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi (Kubikdezimeter) ist das in Gewicht umgerechnete Volumen eines Kartons. Versanddienste nutzen Desi, um leichte, aber sperrige Pakete fair zu berechnen.`)
};

const ru_katalog_desi_page_what_body = /** @type {(inputs: Katalog_Desi_Page_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деси (кубический дециметр): объём коробки, переведённый в вес. Перевозчики используют деси, чтобы справедливо тарифицировать лёгкие, но объёмные посылки.`)
};

/**
* | output |
* | --- |
* | "Desi (cubic decimetre) is the volume of a box converted into weight. Carriers use desi to fairly price light but bulky packages." |
*
* @param {Katalog_Desi_Page_What_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_what_body = /** @type {((inputs?: Katalog_Desi_Page_What_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_What_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_what_body(inputs)
	if (locale === "de") return de_katalog_desi_page_what_body(inputs)
	if (locale === "ru") return ru_katalog_desi_page_what_body(inputs)
	return tr_katalog_desi_page_what_body(inputs)
});